import React, { useState } from "react";
import * as Styled from "./styles";
import Routes from "Routes";
import { TRange } from "Services/pagination";
import { IAd } from "Services/Ad/ad";
import PageTitle from "Components/Base/PageTitle";
import Cities, { ICity } from "Components/Form/Inputs/Cities";
import AdItem from "Components/AdItem";
import { TSegment } from "Services/Segment/segment";
import States, { IState } from "Components/Form/Inputs/States";
import RangeField from "Components/Form/Inputs/RangeField";
import RadioSet from "Components/Form/Inputs/RadioSet";
import CheckboxSearch, {
  IOptions,
} from "Components/Form/Inputs/CheckboxSearch";
import stringRange from "Helpers/stringRange";
import {
  CONVERTABLE_MEASUREMENT_UNITS,
  PROPERTY_FARM_CATEGORY_ID,
  VOCATIONS,
} from "Helpers/consts";
import FilterItems from "Components/Filters/FilterItems";
import Sorting, { TSortingValue } from "Components/Sorting";
import { Categories } from "Components/Filters/Categories";
import List2 from "Components/List2";
import useProperties from "Hooks/Properties/useProperties";
import useCategories from "Hooks/Categories/useCategories";
import arrayToString from "Helpers/arrayToString";
import HeaderPageTitle from "Components/Base/HeaderPageTitle";
import * as Styledd from "../../../Components/Filters2/styles";
import { useSelector } from "react-redux";
import { ReducerState } from "Redux/store";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
interface Props {
  row?: number;
  perPage?: number;
  hideSearch?: boolean;
  hidePagination?: boolean;
  hideFilters?: boolean;
  hideSorting?: boolean;
  inline?: boolean;
  userId?: number;
  segment: TSegment;
  published?: boolean;
  title?: string;
  link?: string;
  setNoResults?: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IVocation {
  name: string;
  value: string;
  id: string;
}

const PropertyList: React.FC<Props> = ({
  row = 3,
  perPage = 12,
  hideSearch = false,
  hideFilters = false,
  hidePagination = false,
  hideSorting = false,
  inline = false,
  userId,
  published = true,
  title,
  link = "",
  segment,
}) => {
  const [sorting, setSorting] = useState<TSortingValue>();
  const [states, setStates] = useState<IState[]>([]);
  const [cities, setCities] = useState<ICity[]>([]);
  const [priceRange, setPriceRange] = useState<TRange>({ min: 0, max: 0 });
  const [sizeRange, setSizeRange] = useState<TRange>({ min: 0, max: 0 });
  const [undefinedPrices, setUndefinedPrices] = useState<boolean>(true);
  const [undefinedSizes, setUndefinedSizes] = useState<boolean>(true);
  const [vocations, setVocations] = useState<IVocation[]>([]);
  const [measureId, setMeasureId] = useState<string>("39");
  const [categoriesSearch, setCategoriesSearch] = useState<string>("");
  const [selectedCategories, setSelectedCategories] = useState<IOptions[]>([]);
  const [showMenu, setShowMenu] = useState(false);
  const { mobile } = useSelector((state: ReducerState) => state.locale);
  const [hideStates, setHideStates] = useState<Record<string, boolean>>({
    states: true,
    cities: true,
    price: true,
    measure: true,
    category: true,
    vocations: true,
  });

  const statesFilter = arrayToString(states);
  const citiesFilter = arrayToString(cities);

  const {
    categoriesError,
    categoriesFilter,
    categoriesOptions,
    categoryByUrl,
  } = useCategories({
    selectedCategories,
    segment: "properties",
    search: categoriesSearch,
    states: statesFilter,
    cities: citiesFilter,
    hideEmpty: true,
  });

  const categoryIds = categoriesFilter.split(",");

  const showVocation =
    (categoryByUrl && categoryByUrl.id === PROPERTY_FARM_CATEGORY_ID) ||
    (categoryIds && categoryIds.includes(PROPERTY_FARM_CATEGORY_ID)) ||
    (!selectedCategories.length && !categoryByUrl)
      ? true
      : false;

  const categoryTitle = categoryByUrl ? ` - ${categoryByUrl.title}` : "";
  const pageTitle = `${segment.title}${categoryTitle}`;

  const suffix = CONVERTABLE_MEASUREMENT_UNITS.find(
    unit => unit.value === measureId
  );

  const sizeSuffix = suffix ? ` ${suffix.name}` : "";

  const toggleHide = (key: string) => {
    setHideStates(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Styled.Container>
      <HeaderPageTitle
        link={""}
        //sideChildren={!hideSorting && <Sorting setSorting={setSorting} />}
      >
        {title ? title : pageTitle}
      </HeaderPageTitle>
      {mobile && (
        <Styled.MobileFilterContainer>
          <Styled.ButtonContainer>
            <div>Ordenar</div>
            <Styled.SelectorContainer>
              <Sorting
                newSelect={true}
                setSorting={setSorting}
                width={15}
                mobileMenu
              />
            </Styled.SelectorContainer>
          </Styled.ButtonContainer>
          <Styled.ButtonContainer
            onClick={() => {
              setShowMenu(!showMenu);
            }}
          >
            Filtrar
          </Styled.ButtonContainer>
        </Styled.MobileFilterContainer>
      )}
      <List2
        useData={useProperties}
        dataParams={{
          segment: segment.segment,
          vocations: vocations.map(vocation => vocation.id).join(","),
          categories: categoriesFilter,
          states: statesFilter,
          cities: citiesFilter,
          price: stringRange(priceRange, setPriceRange),
          size: stringRange(sizeRange, setSizeRange),
          undefinedPrices: undefinedPrices,
          undefinedSizes: undefinedSizes,
          published,
          perPage,
          order: sorting && sorting.order,
          userId: userId && userId,
          measureId,
        }}
        displayOn={showMenu}
        setDisplayOn={setShowMenu}
        hideSearch={hideSearch}
        hideFilters={hideFilters}
        hidePagination={hidePagination}
        sorting={sorting}
        seeMoreLink={link}
        seeMoreText={`Ver mais ${pageTitle && pageTitle.toLowerCase()}`}
        inline={inline}
        segment={segment.segment}
        row={row}
        ItemLayout={(item: IAd) => (
          <AdItem
            viewCount={userId ? true : false}
            item={item}
            link={
              segment.link
                ? segment.link.replace(":slug", item.slug)
                : Routes.property.replace(":slug", item.slug)
            }
          />
        )}
      >
        <>
          <Styledd.Container
            style={{
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Estados
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("states")}>
                    {hideStates["states"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <States
                hideSearch={hideStates["states"]}
                name="states"
                setValue={setStates}
                segment={segment.value}
                label={""}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          <Styledd.Container
            style={{
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Cidades
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("cities")}>
                    {hideStates["cities"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <Cities
                name="cities"
                hideSearch={hideStates["cities"]}
                setValue={setCities}
                states={states}
                segment={segment.segment}
                hiddenLabel={true}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          <Styledd.Container>
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Preço
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("price")}>
                    {hideStates["price"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <RangeField
                title=""
                name="price"
                hideSearch={hideStates["price"]}
                isCurrency={true}
                values={priceRange}
                change={setPriceRange}
                undefinedValues={undefinedPrices}
                setUndefinedValues={setUndefinedPrices}
                undefinedValuesMessage={"Incluir imóveis sem preço"}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          <Styledd.Container>
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Tamanho
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("measure")}>
                    {hideStates["measure"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <RadioSet
                name="measure"
                hideSearch={hideStates["measure"]}
                options={CONVERTABLE_MEASUREMENT_UNITS}
                change={setMeasureId}
                defaultValue={measureId}
              />
              <RangeField
                name="size"
                hideSearch={hideStates["measure"]}
                suffix={sizeSuffix}
                values={sizeRange}
                change={setSizeRange}
                undefinedValues={undefinedSizes}
                setUndefinedValues={setUndefinedSizes}
                undefinedValuesMessage={"Incluir imóveis sem tamanho"}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>

          {!categoryByUrl && (
            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Categorias
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("category")}>
                      {hideStates["category"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <Categories
                  hideSearch={hideStates["category"]}
                  categoriesError={categoriesError}
                  categoryOptions={categoriesOptions}
                  categorySearch={categoriesSearch}
                  selectedCategories={selectedCategories}
                  setCategorySearch={setCategoriesSearch}
                  setSelectedCategories={setSelectedCategories}
                  segment={{
                    name: "properties",
                    subvalue: "imoveis-rurais",
                  }}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}
          {showVocation && (
            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Vocação
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("vocations")}>
                      {hideStates["vocations"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <CheckboxSearch
                  label=""
                  hideSearch={hideStates["vocations"]}
                  options={VOCATIONS}
                  selected={vocations}
                  setSelected={setVocations}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}
          {!mobile && (
            <Styledd.Container style={{ marginBottom: 88 }}>
              <Styledd.SearchContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Ordenar por:
                </Styledd.Title>
                <Sorting newSelect={true} setSorting={setSorting} />
              </Styledd.SearchContainer>
            </Styledd.Container>
          )}
        </>
      </List2>
    </Styled.Container>
  );
};

export default PropertyList;
